import axios from 'axios'
import { errorInterceptor, requestInterceptor, responseInterceptor } from './interceptors'

export function setDefaultUrl(url: string): void {
  axios.defaults.baseURL = url
}

export function manualSetRequestInterceptor(jwt: string): void {
  axios.defaults.headers.common.Authorization = `Bearer ${jwt}`
}

axios.interceptors.request.use(requestInterceptor)
axios.interceptors.response.use(responseInterceptor, errorInterceptor)

export default axios
